import {
  Box,
  Header,
  Index,
  Name,
  PositionList,
  PositionListItem,
  RankDescription,
  Score,
  Title
} from "./styled"
import React from "react"

const Scoreboard = ({
  colors,
  entries,
  title,
  playerCount
}) => {
  return (
    <Box bgColor={colors.secondary}>
      <Header>
        <Title fontColor={colors.leaderboard}>
          {title}
        </Title>
        <RankDescription>
          { entries.length > 5
            ? `Top ${entries.length} Spielenden`
            : `Top ${entries.length} von ${playerCount} Spielenden` }
        </RankDescription>
      </Header>

      <PositionList
        bgColor={colors.leaderboard}
        fontColor={colors.primaryFont}
      >
        {
          entries.map((entry, i) => (
            <PositionListItem
              highlightColor={colors.highlight}
              isHighlighted={entry.isPlayer}
              key={entry.playerName}
            >
              <Index>
                {`${i + 1}.`}
              </Index>
              <Name>
                { entry.playerName }
              </Name>
              <Score>
                { entry.score }
              </Score>
            </PositionListItem>
          ))
        }
      </PositionList>
    </Box>
  )
}

export default Scoreboard
